import { apiConstants } from './shared/config';

const authAccess = { roles: ['SO_00001'], redirect: {name: 'portal.login'}, forbiddenRedirect: '/portal/acesso-negado' };

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "osgestao-home" */ `./views/Home.vue`),
        meta: {
            auth: authAccess,
            hideHeaderName: true,
            title: 'home.title',
        }
    },
    {
        path: `/${apiConstants.code}/pages`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "osgestao-pages" */ './views/page/PageBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.pages`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "osgestao-pages" */ './views/page/PageList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `pages.title`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.pages.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "osgestao-pages" */ './views/page/PageDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `pages.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.pages.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "osgestao-pages" */ './views/page/PageDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `pages.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `pages.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/pagecategories`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "osgestao-pagecategories" */ './views/pagecategory/PageCategoryBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.pagecategories`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "osgestao-pagecategories" */ './views/pagecategory/PageCategoryList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `pagecategories.title`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.pagecategories.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "osgestao-pagecategories" */ './views/pagecategory/PageCategoryDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `pagecategories.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.pagecategories.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "osgestao-pagecategories" */ './views/pagecategory/PageCategoryDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `pagecategories.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `pagecategories.titles`,
        }
    },
];

export default routes;
